import { selectVirtualBackgroundStatus } from 'features/virtual-backgrounds/selectors';
import { SelectedVirtualBackground } from 'features/virtual-backgrounds/types';
import { AppThunk } from 'store/store';
import {
  virtualBackgroundActivationFailed,
  virtualBackgroundChanged,
  virtualBackgroundChangeStarted,
} from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { VirtualBackgroundManager } from 'utils/webrtc/virtual-background/VirtualBackgroundManager';
import { logger } from 'utils/logger';
import { getVirtualBackgroundFailureReason } from 'utils/webrtc/virtual-background/gateErrors';

export const changeVirtualBackground =
  (options: SelectedVirtualBackground): AppThunk =>
  async (dispatch, getState) => {
    const status = selectVirtualBackgroundStatus(getState());
    if (status === 'updating') {
      return;
    }

    dispatch(virtualBackgroundChangeStarted());

    try {
      await VirtualBackgroundManager.changeBackground(options);

      logger
        .remote({ action: true, capture: 'virtual-background' })
        .log('The user changed virtual background', options);

      dispatch(virtualBackgroundChanged(options));
    } catch (error) {
      const reason = getVirtualBackgroundFailureReason(error);
      if (reason) {
        dispatch(virtualBackgroundActivationFailed({ reason, requested: options }));
      }
    }
  };
